var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176ZM19 7.99976H17V10.9998H14V12.9998H17V15.9998H19V12.9998H22V10.9998H19V7.99976ZM4 18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H4Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/UserAdd.9e457cd7.svg";
export { ForwardRef as ReactComponent };